export const APP_NAME: string = 'Device Registration';
export const KEYCLOAK_HOST: string = process.env.REACT_APP_KEYCLOAK_HOST || '';
export const KEYCLOAK_REALM: string =
  process.env.REACT_APP_KEYCLOAK_REALM || '';
export const KEYCLOAK_CLIENTID: string =
  process.env.REACT_APP_KEYCLOAK_CLIENTID || '';
export const KEYCLOAK_MASTER_TOKEN: string = `/auth/realms/${KEYCLOAK_REALM}/protocol/openid-connect/token`;
export const KEYCLOAK_IDP = process.env.REACT_APP_KEYCLOAK_IDP || '';

export const SA_STATE: string = 'ZGV2aWNlLXJlZ2lzdHJhdGlvbjpzdGF0ZS1sb2dpbg==';
export const AUTH_HOST: string = process.env.REACT_APP_AUTHORIZATION_HOST || '';
export const TOKEN_HOST: string =
  process.env.REACT_APP_TOKEN_USER_INFO_HOST || '';
export const SA_CLIENT_ID: string = process.env.REACT_APP_AUTH_CLIENT_ID || '';
export const SA_APP_ALIAS: string = process.env.REACT_APP_AUTH_ALIAS || '';

export const S2S_CLIENT_ID: string = process.env.REACT_APP_S2S_CLIENT_ID || '';
export const S2S_PUBLIC_KEY: string =
  process.env.REACT_APP_S2S_PUBLIC_KEY || '';
export const S2S_RSA_ID: string = process.env.REACT_APP_S2S_RSA_ID || '';

export const SA_PRIVACY_POLICY_URL =
  process.env.REACT_APP_SA_PRIVACY_POLICY_URL || '';
export const ST_PRIVACY_POLICY_URL =
  process.env.REACT_APP_ST_PRIVACY_POLICY_URL || '';
export const VERSION = process.env.REACT_APP_VERSION || '';
export const IS_CHINA = process.env.REACT_APP_IS_CHINA || '';

export const DOORBELL_HOST: string = process.env.REACT_APP_DOORBELL_HOST || '';

export const AXIOS_DEFAULT_DOORBELL_CONFIG = {
  baseURL: process.env.REACT_APP_DOORBELL_HOST,
};

export const gridOption = {
  field: { xl: 24, lg: 24, md: 24, sm: 24 },
  labelCol: { xl: 24, lg: 24, md: 24, sm: 24 },
  labelColSmall: { xl: 4, lg: 4, md: 6, sm: 6 },
  labelColMd: { xl: 8, lg: 8, md: 8, sm: 8 },
  labelCol2: { xl: 15, lg: 16, md: 16, sm: 16 },
  wrapperCol: { xl: 24, lg: 24, md: 24, sm: 24 },
  wrapperCol2: { xl: 9, lg: 8, md: 8, sm: 8 },
  wrapperColSmall: { xl: 20, lg: 20, md: 18, sm: 18 },
  wrapperColMd: { xl: 16, lg: 16, md: 16, sm: 16 },
  wrapperTable1: { xl: 16, lg: 24, md: 24, sm: 24 },
  wrapperTable2: { xl: 12, lg: 18, md: 24, sm: 24 },
  fieldHalf: { span: 12 },
  field11: { span: 11 },
  field2: { span: 2 },
};

export const BILLING_TYPE_NAME = {
  USAGE_BASED: 'Usage-based',
  PRE_PAID: 'Pre-paid',
};

// Export settings
export const SETTINGS_FOR_EXPORT = {
  // Table settings
  fileName: 'example',
  workSheets: [
    {
      sheetName: 'example',
      startingRowNumber: 2,
      gapBetweenTwoTables: 2,
      tableSettings: {
        table1: {
          tableTitle: 'Score',
          headerGroups: [
            {
              name: '',
              key: 'void',
              groupKey: 'directions',
            },
            {
              name: 'Science',
              key: 'science',
              groupKey: 'directions',
            },
            {
              name: 'Directions',
              key: 'directions',
            },
          ],
          headerDefinition: [
            {
              name: '#',
              key: 'number',
            },
            {
              name: 'Name',
              key: 'name',
            },
            {
              name: 'SUM',
              key: 'sum',
              groupKey: 'void',
              rowFormula:
                '{math}+{physics}+{chemistry}+{informatics}+{literature}+{foreignLang}',
            },
            {
              name: 'Mathematics',
              key: 'math',
              groupKey: 'science',
            },
            {
              name: 'Physics',
              key: 'physics',
              groupKey: 'science',
            },
            {
              name: 'Chemistry',
              key: 'chemistry',
              groupKey: 'science',
            },
            {
              name: 'Informatics',
              key: 'informatics',
              groupKey: 'science',
            },
            {
              name: 'Literature',
              key: 'literature',
              groupKey: 'science',
            },
            {
              name: 'Foreign lang.',
              key: 'foreignLang',
              groupKey: 'science',
            },
            {
              name: 'AVG',
              key: 'avg',
              groupKey: 'void',
              rowFormula: '{sum}/6',
            },
          ],
        },
      },
    },
  ],
};

export const KeyTypeArr = ['RSAPUBKEY', 'X509', 'ECPUBKEY', 'AES128ECB'];
export const KeyCurveArr = ['ED25519', 'CURVE25519', 'NISTP256'];
export const userStatusArr = ['pending', 'active', 'inactive', 'approved'];
